import Library from '../utility/Library';
import User from '../../User';
import Reader from './blueprint/Reader';
import { canRerollRelic } from '../utility/relicReroll';

//const MAX_RELICS = 2;
const MAX_POTIONS = 4;

export default class Champion {

	constructor (run, model, params={}) {

		let levelstep = 0;
		this.run = run;
		let data = User.dataFor(model, run.difficultySetting);
		this.model = Library.getChampion(model);
		let healthtrait = data.devotion.health.selected;
		let level = Math.min(params.startingLevel || 1, data.maxLevel);
		this.hp = (((healthtrait+1) * 5) * level) + (40 + 20 * healthtrait);
		this.maxhp = this.hp;
		this.exp = 0;
		this.overflowExp = 0;
		this.gatheredExp = 0;
		this.startingLevel = level;
		this.level = level;
		this.levelReached = level;
		this.levelstep = levelstep;
		this.maxLevel = data.maxLevel;
		this.gold = 50;
		this.arousal = 0;
		this.relics = params.relics?.map(key => Library.upgradeItem(Library.getUpgradedRelic(key), run.power)) || [];
		this.potions = [];
		this.curses = [];
		this.relics.forEach(relic => this.applyRelicPickup(relic, true));
	}

	get id () { return "champion"; }

	get key () { return this.model.key }

	get companion () { return this.run.companion }

	get img () {

		return this.imageFor(this.level);
	}

	get backimg () {

		return this.imageFor(this.level, "back");
	}

	get portrait () {

		return this.portraitFor(this.level);
	}

	get scale () {

		return this.scaleFor(this.level);
	}

	get expbar () {

		return this.exp;
	}

	get potionSlots () {

		return MAX_POTIONS + this.getPassive('potionslots');
	}

	/*
	// For exp = 100 * level

	get threshold () {

		return this.level * 100 * (this.onLevelBreak ? 1 : LEVELBREAK_MULTIPLIER);
	}

	totalExpFor (level) {

		return ((level-1)/2) * level * 100 * LEVELBREAK_MULTIPLIER;
	}*/

	// For exp = 25 * level^2 + 75 * level

	get threshold () {

		return this.thresholdForLevel(this.level);
	}

	thresholdForLevel (level) {

		const expDevotion = this.run.data.devotion.exp.selected || 1;
		const multiplier = 1 + 0.2 * (expDevotion - 1);
		return Math.max(1, Math.round(User.expForLevel(level+1) / multiplier));
	}

	get availableExp () {

		let exp = this.exp + this.overflowExp;
		for (let level = 1; level < this.level; level++)
			exp += this.thresholdForLevel(level);
		return exp;
	}

	/*totalExpFor (level) {

		return 125 * (level + 1) * level * LEVELBREAK_MULTIPLIER; // For 250x
		//return (25 * level + 100) * (level + 1) * level * LEVELBREAK_MULTIPLIER; // For 75x² + 175x
		//return (200 * level + 700) * (level + 1) * level * LEVELBREAK_MULTIPLIER / 6; // For 100x² + 200x
	}*/

	imageFor (level, type="img") {

		if (User.isFetishSoft(this.model.key))
			level = 1;

		let value = null;
		for (let chibi of this.model.chibi) {
			if (chibi.from > level)
				return value;
			value = chibi[type];
		}
		return value;
	}

	portraitFor (level) {

		let value = null;
		for (let portrait of this.model.portrait) {
			if (portrait.from > level)
				return value;
			value = portrait.img;
		}
		return value;
	}

	scaleFor (level) {

		if (User.isFetishSoft(this.model.key))
			level = 1;

		let value = null;
		for (let scale of this.model.scale) {
			if (scale.from > level)
				return value;
			value = scale.value;
		}
		return value;
	}

	computeLevelstep () {

		return Math.max(0, Math.min(10, Math.floor(this.expbar * 10 / this.threshold)))	
	}

	checkLevelUp () {

		if (this.level >= this.maxLevel)
			return false;

		/*let newLevelstep = this.computeLevelstep();
		let steps = Math.max(0, newLevelstep - this.levelstep);
		if (steps) {
			this.levelstep = newLevelstep;
			//this.gainMaxHp((this.run.zen ? 10 : 5) * steps, true);
			this.run.notify('levelstepup', this, newLevelstep);
		}*/

		if (this.expbar < this.threshold)
			return false;

		//this.loseExp(this.level + 1 === this.maxLevel ? this.exp : this.threshold);
		this.levelUp();

		return true;
	}

	checkLevelDown () {

		/*let newLevelstep = this.computeLevelstep();
		let steps = Math.max(0, this.levelstep - newLevelstep);
		if (steps) {
			this.levelstep = newLevelstep;
			//this.loseMaxHp((this.run.zen ? 10 : 5) * steps);
			this.run.notify('levelstepdown', this, newLevelstep);
		}*/

		if (this.expbar >= 0)
			return false;
		if (this.level === 1) {
			this.exp = 0;
			return false;
		}

		this.levelDown();
		//this.gainExp(this.threshold);

		return true;
	}

	levelUp () {

		const threshold = this.threshold;
		this.exp -= threshold;
		this.level++;
		if (this.levelReached < this.level)
			this.levelReached = this.level;
		//this.levelstep = 0;
		this.gainMaxHp((this.run.data.devotion.health.selected+1) * 5, true);
		//let options = this.run.levelUp();
		//this.gainMaxHp(this.level * 40  * (this.run.zen ? (10/4) : (this.run.casual ? (5/4) : 1)), true);
		//this.heal(this.level * 20  * (this.run.zen ? (10/4) : (this.run.casual ? (5/4) : 1)), false);
		this.run.notify('levelup', this, this.level/*, options*/);
		if (this.run.room && this.run.room.fight && !this.run.room.fight.done)
			this.run.room.fight.player.grow();
		if (this.level === this.maxLevel) {
			const overflow = this.exp;
			this.exp = 0;
			this.gainOverflowExp(overflow, false);
		}
		if (this.level < this.maxLevel)
			this.checkLevelUp()
	}

	levelDown () {

		this.level--;
		this.exp += this.threshold;
		//this.levelstep = 10;
		this.loseMaxHp((this.run.data.devotion.health.selected+1) * 5);
		//let options = this.run.levelUp();
		//this.loseMaxHp(this.level * 40  * (this.run.zen ? (10/4) : (this.run.casual ? (5/4) : 1)), true);
		//this.heal(this.level * 20  * (this.run.zen ? (10/4) : (this.run.casual ? (5/4) : 1)), false);
		this.run.notify('leveldown', this, this.level/*, options*/);
		if (this.run.room && this.run.room.fight && !this.run.room.fight.done)
			this.run.room.fight.player.shrink();
		this.checkLevelDown()
	}

	gainExp (amt) {

		if (this.run.memory)
			return;
		if (this.getPassive("cursedtalisman"))
		    amt *= this.getPassive("cursedtalisman")
		if (this.getPassive("wildaura"))
		    amt *= 0.5;
		amt = Math.round(amt);
		if (amt <= 0)
			return;
		this.gatheredExp += amt;
		if (this.level >= this.maxLevel) {
			this.gainOverflowExp(amt);
			return;
		}
		this.exp += amt;
		this.run.notify('gainexp', this, amt);
		this.checkLevelUp()
	}

	loseExp (amt) {

		if (this.run.memory)
			return;
		amt = Math.min(Math.round(amt), this.availableExp);
		if (amt <= 0)
			return;
		const overflowLoss = Math.min(this.overflowExp, amt);
		if (overflowLoss > 0) {
			this.overflowExp -= overflowLoss;
			this.gatheredExp -= overflowLoss;
			this.run.notify('loseoverflowexp', this, overflowLoss);
			amt -= overflowLoss;
		}
		if (amt <= 0)
			return;
		this.exp -= amt;
		this.gatheredExp -= amt;
		this.run.notify('loseexp', this, amt);
		this.checkLevelDown()
	}

	gainOverflowExp (amt, notify=true) {

		amt = Math.round(amt);
		if (amt <= 0)
			return 0;
		this.overflowExp += amt;
		if (notify)
			this.run.notify('gainoverflowexp', this, amt);
		return amt;
	}

	loseOverflowExp (amt) {

		if (this.run.memory)
			return 0;
		amt = Math.min(Math.round(amt), this.overflowExp);
		if (amt <= 0)
			return 0;
		this.overflowExp -= amt;
		this.gatheredExp -= amt;
		this.run.notify('loseoverflowexp', this, amt);
		return amt;
	}

	spendOverflowExp (amt) {

		return this.loseOverflowExp(amt);
	}

	gainGold (amt) {

		amt = Math.round(amt);
		this.gold += amt;
		this.run.notify('gaingold', this, amt);
	}

	loseGold (amt) {

		amt = Math.min(this.gold, amt);
		amt = Math.round(amt);
		if (amt <= 0)
			return;

		this.gold -= amt;
		this.run.notify('losegold', this, amt);
	}

	gainCorruption (amt) {

		if (this.getPassive("preventcorruption"))
		    amt *= this.getPassive("preventcorruption");
		amt = Math.round(amt);
		this.corruption += amt;
		this.run.notify('gaincorruption', this, amt);
	}

	loseCorruption (amt) {

		amt = Math.max(0, Math.min(this.corruption, amt));
		amt = Math.round(amt);
		if (amt <= 0)
			return;

		this.corruption -= amt;
		this.run.notify('losecorruption', this, amt);
	}

	gainArousal (amt) {

		amt = Math.round(amt);
		this.arousal += amt;
		this.run.notify('gainarousal', this, amt);
	}

	loseArousal (amt) {

		amt = Math.max(0, Math.min(this.arousal, amt));
		amt = Math.round(amt);
		if (amt <= 0)
			return;

		this.arousal -= amt;
		this.run.notify('losearousal', this, amt);
	}

	heal (amt) {

		amt = Math.min(amt, this.maxhp - this.hp);
		const overrideheal = this.run.room.fight && this.run.room.fight.enemies.some(e => e.hasStatus("cowgirl-contest"));
		if (!overrideheal && this.curses.some(curse => curse.key === "darkness"))
			amt /= 2;
		amt = Math.round(amt);
		
		if (!amt || amt < 0)
			return;

		this.hp += amt;
		this.run.notify('lifegain', this, amt);
	}

	loseLife (amt) {

		amt = Math.round(amt);
		if (!amt || amt < 0)
			return;

		this.hp -= amt;
		this.run.notify('lifeloss', this, null, amt);
		
		if (this.hp <= 0) {
			let fairyindex = this.potions.findIndex(potion => potion.key === "fairy-in-a-bottle");
			if (fairyindex >= 0) {
				this.usePotion(fairyindex, true);
				this.heal(Math.ceil(this.maxhp/4));
			} else
				this.run.gameOver();
		}
	}

	gainMaxHp (amt, heal=true) {

		amt = Math.round(amt);
		this.maxhp += amt;
		if (heal)
			this.hp += amt;
		this.run.notify('gainmaxhp', this, amt, heal);
	}

	loseMaxHp (amt) {

		amt = Math.round(amt);
		this.maxhp -= amt;
		this.hp = Math.min(this.hp, this.maxhp)
		this.run.notify('losemaxhp', this, amt);
	}

	getPassive (passive) {

	    let isString = false;
	    let resultNum = 0;
	    let resultStr = [];

	    // Check relics
	    for (let relic of this.relics) {
	        if (relic.passive && relic.passive.name === passive) {
	            if (typeof relic.passive.value === "string") {
	                isString = true;
	                resultStr.push(relic.passive.value);
	            } else {
	                resultNum += relic.passive.value;
	            }
	        }
	    }

	    // Check deck cards
	    for (let card of this.run.deck) {
	        if (card.card.passive && card.card.passive.name === passive) {
	            if (typeof card.card.passive.value === "string") {
	                isString = true;
	                resultStr.push(card.card.passive.value);
	            } else {
	                resultNum += card.card.passive.value;
	            }
	        }
	    }

	    return isString ? resultStr : resultNum;
	}

	applyRelicPickup (relic, runStart=false) {

		if (relic.pickup) {
			if (relic.pickup.hp && !runStart)
				this.heal(relic.pickup.hp);
			if (relic.pickup.entropy && !(relic.pickup.rarecardchoice && !runStart))
				this.run.changeMinDeckSize(relic.pickup.entropy);
			if (relic.pickup.curse && !runStart)
				this.applyCurse(relic.pickup.curse);
			if (relic.pickup.paws)
				this.run.addPaws(relic.pickup.paws);
			if (relic.pickup.maxhp)
				this.gainMaxHp(relic.pickup.maxhp);
			if (relic.pickup.gold && !runStart)
				this.gainGold(relic.pickup.gold);
			if (relic.pickup.potions && !runStart) {
			        let items = Object.values(Library.potions)
			            .filter(item =>
			                item.rarity && (!item.rank || this.run.power >= item.rank) &&
		                (!item.champion || item.champion === this.model.key)
		            );
				for (let i = 0; i < relic.pickup.potions && this.potions.length < this.potionSlots; i++)
					this.newPotion(items[Math.floor(Math.random() * items.length)]);
			}
			if (relic.pickup.commons && !runStart)
		        this.run.addRandomCard(relic.pickup.commons, c => c.rarity && c.rarity === 1);
			if (relic.pickup.uncommons && !runStart)
		        this.run.addRandomCard(relic.pickup.uncommons, c => c.rarity && c.rarity === 2);
			if (relic.pickup.rarecardchoice && !runStart) {
				if (relic.pickup.entropy)
					this.run.pendingCardChoiceEffects = Object.assign({}, this.run.pendingCardChoiceEffects, {
						entropy: (this.run.pendingCardChoiceEffects?.entropy || 0) + relic.pickup.entropy
					});
				this.run.cardChoiceWith(this.run.generateCardChoices(relic.pickup.rarecardchoice, true), true);
			}
			if (relic.pickup.cards && !runStart) {
		        let cards = this.cardpool;
				for (let i = 0; i < relic.pickup.cards; i++)
					this.run.addCard(this.run.getUpgradedCard(cards[Math.floor(Math.random() * cards.length)]));
			}
			if (relic.pickup.transformbasic && !runStart) {
		        let cards = this.cardpool
			        .filter(c =>
			            c.rarity && c.rarity === 1
			        );
			    let flag = true;
			    while (flag) {
			    	flag = false;
			    	for (let i = 0; i < this.run.deck.length; i++) {
			    		let deckcard = this.run.deck[i].card;
			    		if ((deckcard.originalName || deckcard.name) === "Strike" || (deckcard.originalName || deckcard.name) === "Defend") {
			    			flag = true;
			    			this.run.removeCard(i);
			    			this.run.addCard(this.run.getUpgradedCard(cards[Math.floor(Math.random() * cards.length)]), false);
			    		}
			    	}
			    }
			}
		}
	}

	newRelic (relic) {

		relic = Library.upgradeItem(relic, this.run.power);
		this.relics.push(relic);

		this.applyRelicPickup(relic);
		User.learn("relics", relic.key);

		this.run.notify('relic', this, relic);

		/*if (this.relics.length > MAX_RELICS) {
			this.run.droppingRelic = true;
			this.run.notify('droppingrelic', this);
		}*/
	}

	loseRelic (key) {

		this.relics = this.relics.filter(r => r.key !== key);

		this.run.notify('loserelic', this, key);
	}

	dropRelic (no) {

		this.relics.splice(no, 1);
		delete this.run.droppingRelic;
		this.run.notify('droprelic', this, no);
	}

	applyCurse (key) {

		if (this.curses.some(curse => curse.key === key) || this.getPassive("nocurse"))
			return;

		this.curses.push(Library.getCurse(key));
		this.run.notify('curse', this, key);
	}

	cureRandomCurse () {

		if (this.curses.length === 0)
			return;

		const index = Math.floor(Math.random() * this.curses.length);
		const curse = this.curses[index];
		this.curses.splice(index, 1);
		this.run.notify('curecurse', this, curse.key);
	}

	get cardpool () {

		//return User.cardsFor(this.model.key, this.run.difficulty)
		const level = User.dataFor(this.model.key, this.run.difficultySetting).level;
		return Object.values(Library.cards).filter(c => c.champion === this.model.key && c.rarity && !c.token && (!c.level || c.level <= level));
	}

	randomEffect (value) {

		let type = Math.floor(Math.random() * 14)

		switch (type) {
		case 0: this.gainExp(value * 10); break;
		case 1: this.loseExp(value * 5); break;
		case 2: this.heal(value * 20); break;
		case 3: this.gainMaxHp(value * 10); break;
		case 4: if (this.maxhp > value * 5) this.loseMaxHp(value * 5); else this.gainMaxHp(value * 10); break;
		case 5: this.run.changeTime(value * 10); break;
		case 6: this.run.changeTime(-value * 5); break;
		case 7: this.run.dropChoice(); break;
		case 8: this.teleport(); break;
		case 9: let cardpool = this.cardpool; this.run.addCard(cardpool[Math.floor(Math.random() * cardpool.length)]); break;
		case 10: this.run.revealMap(); break;
		case 11: this.gainGold(value * 20); break;
		case 12: this.loseGold(value * 10); break;
		case 13: if (this.hp > value * 10) this.loseLife(value * 10); else this.heal(value * 20); break;
		}
	}

	canUsePotion (no) {

		let item = this.potions[no];

		if (item.unusable)
			return false;
		if (item.fight)
			return this.run.room.fight && !this.run.room.fight.done && (!item.companion || this.run.companion);
		if (item.menagerie)
			return this.run.room?.model.type === "menagerie";
		if (item.fountain)
			return this.run.room?.fountain;
		if (item.activefountain)
			return this.run.room?.fountain && this.run.room.fountain.active;
		if (item.mezurishop)
			return this.run.room?.shop && this.run.room.shop.mezuri && (!item.bonus?.shopdiscount || !this.run.room.variables.discountedshop);
		if (item.shop)
			return this.run.room?.model.type === "shop";
		if (item.nextshop)
			return 16 - this.run.time < 15;
		if (item.relic)
			return (this.run.room?.collectables.some(canRerollRelic) || this.run.room?.treasure?.collectables.some(canRerollRelic)) && !this.run.room.shop;
		if (item.cardchoice)
			return this.run.choosingCard;

		return true;
	}

	usePotion (no, force=false) {

		if (this.potions.length <= no)
			return;

		let item = this.potions[no];
		let repeatPotions = this.potions.filter(potion => potion.key === "repeat-potion");

		if (!force && !this.canUsePotion(no))
			return;

		this.run.notify('drinkpotion', this, no);

		if (item.bonus) {
			if (item.bonus.gold)
				this.gainGold(item.bonus.gold);
			if (item.bonus.exp)
				this.gainExp(item.bonus.exp);
			if (item.bonus.corruption && item.bonus.corruption > 0)
				this.gainCorruption(item.bonus.corruption);
			if (item.bonus.corruption && item.bonus.corruption < 0)
				this.loseCorruption(-item.bonus.corruption);
			if (item.bonus.curse)
				this.applyCurse(item.bonus.curse);
			if (item.bonus.curecurse)
				for (let i = 0; i < item.bonus.curecurse; i++)
					this.cureRandomCurse();
			if (item.bonus.mininsight && this.run.insight < item.bonus.mininsight)
				this.run.addInsight(item.bonus.mininsight - this.run.insight);
			if (item.bonus.hp)
				this.heal(item.bonus.hp);
			if (item.bonus.paws)
				this.run.addPaws(item.bonus.paws);
			if (item.bonus.companionskill && this.run.room?.fight?.player && this.run.companion)
				this.run.room.fight.player.triggerSkill();
			if (item.bonus.fountainheal && this.run.room?.fountain)
				this.heal(this.run.restHealing * item.bonus.fountainheal);
			if (item.bonus.entropy)
				this.run.changeMinDeckSize(item.bonus.entropy);
			if (item.bonus.maxhp)
				this.gainMaxHp(item.bonus.maxhp);
			if (item.bonus.time)
				this.run.changeTime(item.bonus.time);
			if (item.bonus.removecard)
				this.run.dropChoice(true);
			if (item.bonus.escape)
				this.run.victory();
			if (item.bonus.strange)
				this.randomEffect(item.bonus.strange);
			if (item.bonus.map)
				this.run.revealMap();
			if (item.bonus.remove)
				this.run.dropChoice(true);
			if (item.bonus.duplicate)
				this.run.duplicateChoice();
			if (item.bonus.cardreroll && this.run.choosingCard) {
				this.run.reroll = true;
				this.run.skipChoice();
			}
			if (item.bonus.relicreroll) {
				[this.run.room, this.run.room?.treasure].forEach(source => {
					if (!source)
						return;
					source.collectables.forEach((col,i) => {
						if (!canRerollRelic(col))
							return;

						let relics = Object.values(Library.relics);
						relics = relics.filter(relic => relic.pool === "treasure" && (!relic.champion || relic.champion === this.model.key))
						relics = relics.filter(relic => !this.relics.some(r => r.key === relic.key))

						let relic = Library.upgradeItem(relics[Math.floor(Math.random() * relics.length)], this.run.power);
						if (source.changeCollectable)
							this.run.room.changeCollectable(i, relic);
						else {
							source.remove(i);
							source.generateTreasure("relic", relic);
						}
					})
				})
			}
			if (item.bonus.shopdiscount && this.run.room?.shop && !this.run.room.variables.discountedshop) {
				this.run.room.shop.applyDiscount(item.bonus.shopdiscount);
				this.run.room.variables.discountedshop = true;
			}
			if (item.bonus.goldmultiplier)
				this.gainGold(this.gold * (item.bonus.goldmultiplier-1));
			if (item.bonus.nextshop) {
				const currentLayer = 16 - this.run.time;
				const nextLayer = this.run.map?.sections[currentLayer + 1];
				const connectedRooms = this.run.room?.model.next || [];
				const shop = Object.values(Library.getEvents(this.run.power)).find(event => event.type === "shop");
				const changedRooms = [];
				connectedRooms.forEach(index => {
					const room = nextLayer?.[index];
					if (!room || !shop)
						return;
					const topology = { index: room.index, next: room.next };
					Object.keys(room).forEach(key => delete room[key]);
					Object.assign(room, shop, topology, { type: "shop" });
					changedRooms.push({ index, model: Object.assign({}, room) });
				});
				this.run.notify("maproomstoshops", this.run, currentLayer + 1, changedRooms);
			}
			if (item.bonus.worshipmultiplier && this.run.room?.fountain) {
				this.gainExp(this.run.worshipExp * item.bonus.worshipmultiplier);
			}
			if (item.bonus.exprewardmultiplier && this.run.room && !this.run.room.variables.doubleexp) {
				this.run.room.collectables.forEach((c, i) => {
					if (c && c.type === "exp")
						this.run.room.changeCollectable(i, c.value * (item.bonus.exprewardmultiplier));
				});
				this.run.room.variables.doubleexp = true;
			}
			if (item.bonus.goldrewardmultiplier && this.run.room && !this.run.room.variables.doublegold) {
				this.run.room.collectables.forEach((c, i) => {
					if (c && c.type === "gold")
						this.run.room.changeCollectable(i, c.value * (item.bonus.goldrewardmultiplier));
				});
			}
			if (item.bonus.runerewardmultiplier && this.run.room && !this.run.room.variables.doublegold)
				this.run.room.collectables.forEach((c, i) => {
					if (c && c.type === "runes")
						this.run.room.changeCollectable(i, c.value * (item.bonus.runerewardmultiplier));
				});
			if (item.bonus.goldrewardmultiplier && this.run.room)
				this.run.room.variables.doublegold = true;
		}

		if (item.blueprint) {

			let fightitem = {
				master: this.run.room.fight,
				variables: {},
				setVariable (name, value) {
					this.variables[name] = value;
				},
				getVariable (name) {
					return this.variables[name];
				},
				clearVariable (name) {
					delete this.variables[name];
				}
			}
			Reader.read(item.blueprint, fightitem);
			if (fightitem.events)
				fightitem.events.forEach(e => e());
		}

		if (this.getPassive("potionheal"))
			this.heal(this.getPassive("potionheal"));

		if (item.next)
			this.potions[no] = Library.upgradeItem(Library.getPotion(item.next), this.run.power);
		else
			this.potions.splice(no, 1);
		repeatPotions.forEach(potion => {
			let repeatIndex = this.potions.indexOf(potion);
			if (repeatIndex >= 0)
				this.potions[repeatIndex] = Object.assign({}, item);
		});
		if (this.potions.length <= this.potionSlots)
			delete this.run.droppingPotion;
		this.run.notify('usepotion', this, no, item);
	}

	dropPotion (no) {

		if (this.potions.length <= no)
			return;

		this.potions.splice(no, 1);
		if (this.potions.length <= this.potionSlots)
			delete this.run.droppingPotion;
		this.run.notify('droppotion', this, no);
	}

	newPotion (item) {

		if (this.potions.length > this.potionSlots)
			return;

		item = Library.upgradeItem(item, this.run.power);
		this.potions.push(item);

		User.learn("potions", item.key);
		this.run.notify('potion', this, item);

		if (this.potions.length > this.potionSlots) {
			this.run.droppingPotion = true;
			this.run.notify('droppingpotion', this);
		}
	}

	serialize () {

		return {
			model: this.model.key,
			maxhp: this.maxhp,
			hp: this.hp,
			exp: this.exp,
			overflowExp: this.overflowExp,
			gatheredExp: this.gatheredExp,
			startingLevel: this.startingLevel,
			levelReached: this.levelReached,
			level: this.level,
			levelstep: this.levelstep,
			maxLevel: this.maxLevel,
			gold: this.gold,
			corruption: this.corruption,
			relics: this.relics.map(relic => relic.key),
			potions: this.potions.map(item => item.key),
			curses: this.curses.map(curse => curse.key)
		}
	}

	static build (run, src) {

		let champion = new Champion(run, src.model);
		champion.maxhp = src.maxhp;
		champion.hp = src.hp;
		champion.exp = src.exp;
		champion.overflowExp = src.overflowExp || 0;
		champion.gatheredExp = src.gatheredExp;
		champion.startingLevel = src.startingLevel;
		champion.levelReached = src.levelReached;
		champion.level = src.level;
		champion.levelstep = src.levelstep;
		champion.maxLevel = Math.min(src.maxLevel, User.dataFor(src.model, run.difficultySetting).maxLevel);
		champion.gold = src.gold;
		champion.corruption = src.corruption;
		champion.relics = src.relics.map(relic => Library.upgradeItem(Library.getRelic(relic), run.power));
		champion.potions = src.potions.map(item => Library.upgradeItem(Library.getPotion(item), run.power));
		champion.curses = (src.curses || []).map(curse => Library.getCurse(curse));
		return champion;
	}
}
